import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Send, Loader2, Check } from "lucide-react";

export default function NewsletterSignup() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await api.post("/newsletter", { email });
      setDone(true);
      toast.success("Subscribed! Thanks for joining our community.");
    } catch {
      toast.error("Could not subscribe. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="newsletter-signup">
      <h4 className="font-display font-semibold text-white text-sm tracking-wide uppercase">Stay Connected</h4>
      <p className="mt-3 text-sm text-slate-400">Get updates on programs, events, and impact.</p>
      {done ? (
        <p data-testid="newsletter-success" className="mt-4 inline-flex items-center gap-2 text-sm text-green-400">
          <Check className="h-4 w-4" /> You're subscribed!
        </p>
      ) : (
        <form onSubmit={submit} className="mt-4 flex gap-2">
          <input
            data-testid="newsletter-email"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Your email"
            className="min-w-0 flex-1 rounded-full bg-slate-800 border border-slate-700 px-4 py-2.5 text-sm text-white placeholder:text-slate-500 outline-none focus:ring-2 focus:ring-accent/40"
          />
          <button
            data-testid="newsletter-submit"
            disabled={loading}
            className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-accent text-white transition hover:bg-orange-400 disabled:opacity-60"
            aria-label="Subscribe"
          >
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />}
          </button>
        </form>
      )}
    </div>
  );
}
